import { useState, useEffect, useCallback, useRef } from 'react';
import { api, LitLegionNpc } from '@/lib/api';

interface UseAdminNpcsReturn {
  npcs: LitLegionNpc[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useAdminNpcs(): UseAdminNpcsReturn {
  const [npcs, setNpcs] = useState<LitLegionNpc[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const refreshRef = useRef(0);

  const fetchNpcs = useCallback(async () => {
    const id = ++refreshRef.current;
    try {
      setLoading(true);
      setError(null);
      const result = await api.adminListLitLegionNpcs();
      if (refreshRef.current === id) {
        setNpcs(result.npcs);
      }
    } catch (err) {
      if (refreshRef.current === id) {
        setError(err instanceof Error ? err.message : 'Failed to load NPCs');
      }
    } finally {
      if (refreshRef.current === id) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchNpcs();
    return () => {
      refreshRef.current++;
    };
  }, [fetchNpcs]);

  return {
    npcs,
    loading,
    error,
    refresh: fetchNpcs,
  };
}
